import React, { FC, useState } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { Button, FieldGroup } from '@xsolla/ui-core';
import { Plus } from '@xsolla/ui-icons';

import { DEFAULT_XSOLLA_ACCOUNT_VALUES } from '../../../../constants';
import { ScopeInput } from './ScopeInput';
import { IconWrapper, TagsWrapper } from './styles';
import { TagItem } from './TagItem';

export const ScopesFormField: FC<{
  dataTestId: string;
  scopes: string[];
  disabledScopes?: string[];
  hiddenScopes?: string[];
  onAdd: (scope: string) => void;
  onDelete: (scope: string) => void;
}> = ({ dataTestId, scopes, disabledScopes, hiddenScopes, onAdd, onDelete }) => {
  const [inputMode, setInputMode] = useState(false);
  const intl = useIntl();

  return (
    <Field name="scopes">
      {() => {
        const filteredScopes = scopes.filter((scope) => !hiddenScopes?.includes(scope));

        const handleAddScope = (scope: string) => {
          setInputMode(false);
          onAdd(scope);
        };

        // TODO: Remove this once OAuth2 scopes behavior is finalized; currently hiding scopes until clarified
        if (DEFAULT_XSOLLA_ACCOUNT_VALUES.IS_SCOPES_HIDDEN) {
          return null;
        }

        return (
          <FieldGroup
            label={intl.formatMessage({
              id: 'authorization.settings.babkaLogin.modal.connect.scope.title'
            })}>
            <TagsWrapper>
              {filteredScopes.map((scope) => (
                <TagItem
                  key={scope}
                  value={scope}
                  disabled={disabledScopes?.includes(scope)}
                  onClick={onDelete}
                />
              ))}
            </TagsWrapper>

            {inputMode ? (
              <ScopeInput
                dataTestId={`${dataTestId}-edit`}
                onAdd={handleAddScope}
                onCancel={() => setInputMode(false)}
                scopes={scopes}
              />
            ) : (
              <Button
                data-test-id={`${dataTestId}-add-button`}
                type="button"
                onClick={() => setInputMode(true)}
                look="link"
                palette="brand"
                size="md">
                <IconWrapper>
                  <Plus size={16} />
                </IconWrapper>
                {intl.formatMessage({ id: 'authorization.settings.babkaLogin.scopes.add-button' })}
              </Button>
            )}
          </FieldGroup>
        );
      }}
    </Field>
  );
};
